import { MapPin, ArrowUpRight } from "lucide-react";
import { CONNECTIVITY, SITE } from "../../lib/data";

const MAP_QUERY = encodeURIComponent(
  "Amarja Hills, Mahagaon Road, Pawna Dam, Lonavala, Maharashtra"
);

/**
 * MapSection — light editorial location block.
 */
export default function MapSection() {
  return (
    <section
      id="map"
      data-testid="map-section"
      className="bg-[#F7F5F0] text-[#1A362D] py-20 md:py-32"
    >
      <div className="max-w-[100rem] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-12 md:mb-16 items-end">
          <h2 className="reveal lg:col-span-7 font-serif-display text-[2.5rem] sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight font-light">
            At Mahagaon Road, <br />
            <em className="font-normal">Pawna Dam, Lonavala.</em>
          </h2>
          <p className="reveal lg:col-span-5 text-[#3A453B] text-base md:text-lg leading-relaxed max-w-md">
            A private hill estate, perfectly positioned between Mumbai and Pune.
          </p>
        </div>

        {/* Map embed */}
        <div
          data-testid="map-embed"
          className="relative w-full aspect-[4/3] sm:aspect-[16/9] md:aspect-[21/9] overflow-hidden border border-[#1A362D]/15 bg-[#EBE7DF]"
        >
          <iframe
            title="Amarja Hills location map"
            src={`https://www.google.com/maps?q=${MAP_QUERY}&output=embed&z=12`}
            width="100%"
            height="100%"
            style={{ border: 0, filter: "grayscale(35%) contrast(0.98)" }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>

        <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-start gap-3 text-[#3A453B] text-sm md:text-base">
            <MapPin
              className="w-5 h-5 text-[#987F53] mt-0.5 flex-shrink-0"
              strokeWidth={1.5}
            />
            <span>{SITE.estateAddress}</span>
          </div>
          <a
            data-testid="map-directions"
            href={`https://www.google.com/maps/search/?api=1&query=${MAP_QUERY}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[11px] tracking-[0.24em] uppercase font-semibold text-[#1A362D] hover:text-[#987F53] border-b border-[#1A362D] hover:border-[#987F53] pb-1 self-start"
          >
            Get Directions <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        {/* Distances grid */}
        <div className="mt-14 md:mt-20">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#1A362D]/15">
            {CONNECTIVITY.map((c, i) => (
              <div
                key={c.place}
                data-testid={`connectivity-${i}`}
                className="bg-[#F7F5F0] p-6 md:p-7"
              >
                <p className="font-serif-display text-3xl sm:text-4xl text-[#1A362D] leading-none font-light">
                  {c.time}
                </p>
                <p className="text-[10px] sm:text-xs tracking-[0.18em] uppercase text-[#4A524D] mt-3 leading-tight">
                  {c.place}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
